export enum UserReportTypeEnum {
  Installer = 'installer',
}
